/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum ActivityType {
  Default = "default_",
  GeneralRequest = "general_request",
  MessageRequest = "message_request",
  DocumentRequest = "document_request",
  QuestionRequest = "question_request",
  Acknowledgement = "acknowledgement",
  Created = "created",
  Review = "review",
  Root = "root",
}

export function instanceOfActivityType(value: any): boolean {
  for (const key in ActivityType) {
    if (Object.prototype.hasOwnProperty.call(ActivityType, key)) {
      if (ActivityType[key as keyof typeof ActivityType] === value) {
        return true;
      }
    }
  }
  return false;
}

export function ActivityTypeFromJSON(json: any): ActivityType {
  return ActivityTypeFromJSONTyped(json, false);
}

export function ActivityTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ActivityType {
  return json as ActivityType;
}

export function ActivityTypeToJSON(value?: ActivityType | null): any {
  return value as any;
}

export function ActivityTypeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): ActivityType {
  return value as ActivityType;
}
